import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'admin-pairing',
  templateUrl: './pairing.component.html',
})
export class AdminPairingComponent {
  public pairingForm: FormGroup;
  public results: string[] = [];
  public busy: boolean = false;

  constructor(private http: HttpClient,
    private aRoute: ActivatedRoute) {

    this.pairingForm = new FormGroup({
      ladderId: new FormControl(''),
      levelId: new FormControl(''),
    });
    this.aRoute.queryParams.subscribe(params => {
      this.pairingForm.controls.ladderId.setValue(params.ladderid);
    });

  }

  public doitSingles(evt) {
    this.results.length = 0;
    this.busy = true;
    this.http.get(`/Pairing/PairAll?levelId=${this.pairingForm.value.levelId}&ladderId=${this.pairingForm.value.ladderId}`).subscribe(
      (resp: { result: string[] }) => {
        console.log(resp)
        this.results = resp.result;
        this.busy = false;
      },
      (err) => {
        console.error(err);
        this.busy = false;
      }

    )
  }
  public doitDoubles(evt) {
    this.results.length = 0;
    this.busy = true;
    this.http.get(`/Pairing/PairAll/Doubles?levelId=${this.pairingForm.value.levelId}&ladderId=${this.pairingForm.value.ladderId}`).subscribe(
      (resp: { result: string[] }) => {
        console.log(resp)
        this.results = resp.result;
        this.busy = false;
      },
      (err) => {
        console.error(err);
        this.busy = false;
      }

    )
  }

}
